module.exports = __webpack_public_path__ + "static/media/plano_concepcion.6c4276fa.png";